import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import Modal from "../../general/Modal";
import ActionStatus from "./ActionStatus";
import RemoteTable from "../RemoteTable";
function ActionModal(props) {
    const { objectType } = props;
    // ActionStatus will be cellRenderer at some point
    return (_jsxs(Modal, { ...props, size: "full", closeButton: true, children: [_jsxs("h5", { style: { paddingBottom: 20 }, children: ["Actions run on '", objectType, "'"] }), _jsx(RemoteTable, { basic: true, noConfigModal: true, noDownload: true, noFilter: true, id: "action-table", endpoint: "local/user_action", height: 500, defaultSort: "-created_at", fields: {
                    "action.name": {
                        rename: "Action",
                    },
                    ids: {
                        rename: "IDs",
                        width: 500,
                    },
                    "status": {
                        rename: "Status",
                        width: 300,
                        custom: true,
                        cellRenderer: {
                            element: ActionStatus,
                        },
                    },
                    "user.oidc_id": {
                        rename: "User",
                    }
                } })] }));
}
export default ActionModal;
